<div
  class="component-content heightcls"
  style="
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
  "
>
  <!-- Busy overlay (download) -->
  <div
    *ngIf="isDownloading"
    class="mat-overlay"
    style="
      position: absolute;
      inset: 0;
      background: rgba(255, 255, 255, 0.7);
      z-index: 50;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    "
  >
    <i class="fa fa-spinner fa-spin fa-pulse fa-2x" style="color: #004288"></i>
  </div>

  <!-- Toolbar -->
  <div
    style="
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 15px;
      margin-bottom: 1rem;
    "
  >
    <mat-form-field
      appearance="outline"
      class="mat-form-field-custom"
      style="flex-grow: 1"
      *ngIf="dataSource?.data?.length"
    >
      <mat-label>Quick Filter</mat-label>
      <input
        #quickFilterInput
        matInput
        [(ngModel)]="localFilter"
        (ngModelChange)="applyLocalFilter()"
        placeholder="Type to filter"
      />
      <button
        *ngIf="localFilter"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        title="Clear"
        (click)="clearLocalFilter(quickFilterInput)"
      >
        <mat-icon fontSet="fa" fontIcon="fa-times"></mat-icon>
      </button>
    </mat-form-field>
    <div style="display: flex; flex-direction: column">
      <div style="display: flex; flex-flow: nowrap; gap: 5px">
        <button
          class="btn btn-primary btn-sm"
          (click)="addFMIProduct()"
          title="Add Doc"
        >
          <i class="fa fa-fw fa-plus"></i>
        </button>
        <button
          class="btn btn-sm"
          [class.btn-warning]="filterApplied"
          [class.btn-primary]="!filterApplied"
          (click)="openFilter()"
          title="Filter Documents"
        >
          <i class="fa fa-filter"></i>
        </button>
      </div>
      <div style="text-align: right; font-size: 12px; color: #666">
        <span>Avail Docs: {{ total }} / {{ totalDocuments }}</span>
      </div>
    </div>
  </div>

  <div style="flex: 1; overflow: auto; position: relative">
    <!-- Loading overlay (keeps table in DOM so sort state persists) -->
    <div
      *ngIf="processing"
      style="
        position: absolute;
        inset: 0;
        background: rgba(255, 255, 255, 0.55);
        z-index: 25;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      "
    >
      <i
        class="fa fa-spinner fa-spin fa-pulse fa-2x"
        style="color: #004288; margin-bottom: 8px"
      ></i>
      <span style="font-size: 13px; color: #004288; font-weight: 600"
        >Loading...</span
      >
    </div>
    <!-- Local styles for table header background -->
    <style>
      /* Ensure sticky header retains background above rows */
      .fmiproduct-mat-table thead,
      .fmiproduct-mat-table th {
        background: #f5f5f5 !important;
      }
      .fmiproduct-mat-table th {
        box-shadow: inset 0 -2px 0 rgba(0, 0, 0, 0.12);
        line-height: 1.2;
      }
    </style>
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      matSortDisableClear
      (matSortChange)="onSortChange($event)"
      class="mat-elevation-z8 fmiproduct-mat-table"
      style="width: 100%"
    >
      <!-- Publication Number -->
      <ng-container matColumnDef="ProductName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Publication Number
        </th>
        <td mat-cell *matCellDef="let row">{{ row.ProductName }}</td>
      </ng-container>

      <!-- Manual Title -->
      <ng-container matColumnDef="ProductDescription">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Manual Title</th>
        <td mat-cell *matCellDef="let row" style="white-space: normal">
          {{ row.ProductDescription }}
        </td>
      </ng-container>

      <!-- Created Date -->
      <ng-container matColumnDef="CreatedOn">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Created Dt</th>
        <td mat-cell *matCellDef="let row">
          {{ row.CreatedOn | amDateFormat: 'MM/DD/YYYY' }} at {{ row.CreatedOn |
          amDateFormat: 'hh:mm A' }}
        </td>
      </ng-container>

      <!-- Created By -->
      <ng-container matColumnDef="CreatedBy">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Created By</th>
        <td mat-cell *matCellDef="let row" style="word-break: break-word">
          {{ row.CreatedBy }}
        </td>
      </ng-container>

      <!-- Division -->
      <ng-container matColumnDef="Division">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Division</th>
        <td mat-cell *matCellDef="let row">{{ row.Division }}</td>
      </ng-container>

      <!-- ProManual Manual Title -->
      <ng-container matColumnDef="ProManualTitle">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          ProManual Manual Title
        </th>
        <td mat-cell *matCellDef="let row" style="word-break: break-word">
          {{ row.ProManualTitle }}
        </td>
      </ng-container>

      <!-- Version -->
      <ng-container matColumnDef="Version">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Version</th>
        <td mat-cell *matCellDef="let row">{{ row.Version }}</td>
      </ng-container>

      <!-- Titania -->
      <ng-container matColumnDef="TitaniaUrl">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Titania</th>
        <td mat-cell *matCellDef="let row">
          <a
            *ngIf="row.TitaniaUrl"
            href="{{ row.TitaniaUrl }}"
            target="_blank"
            rel="noopener"
          >
            <i class="fa fa-external-link" aria-hidden="true"></i>
          </a>
          <span *ngIf="!row.TitaniaUrl">-</span>
        </td>
      </ng-container>

      <!-- Actions -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row" style="min-width: 220px">
          <div class="btn-group btn-group-sm">
            <button
              class="btn btn-primary"
              title="Details / Edit"
              [disabled]="disable"
              (click)="edit(row)"
            >
              <i class="fa fa-list-alt"></i>
            </button>
            <button
              class="btn btn-primary"
              title="Download"
              [disabled]="disable"
              (click)="download(row)"
            >
              <i class="fa fa-download"></i>
            </button>
            <button
              class="btn btn-primary"
              title="Duplicate"
              [disabled]="disable"
              (click)="duplicate(row)"
            >
              <i class="fa fa-files-o"></i>
            </button>
            <button
              class="btn btn-primary"
              title="Delete Document"
              [disabled]="disable"
              (click)="remove(row)"
            >
              <i class="fa fa-trash-o"></i>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <div
      *ngIf="dataSource?.data?.length === 0"
      style="padding: 12px; text-align: center; color: #777"
    >
      No documents found.
    </div>
  </div>
</div>

<div
  bsModal
  #fmisearchModal="bs-modal"
  style="z-index: 1070; padding: 20px"
  id="fmisearchModal"
  class="modal fade"
  [config]="{ keyboard: false, backdrop: 'static' }"
  tabindex="-1"
  z-index="100"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          aria-hidden="true"
          (click)="closeFMISearch()"
        >
          &times;
        </button>
        <h4 class="modal-title" id="myModalLabel1">
          <span>Pull Document from FMI</span>
        </h4>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group input-group has-feedback">
              <div class="row">
                <div class="col-lg-4">
                  <label
                    class="input-group-addon"
                    style="
                      width: 200px;
                      display: inline-block;
                      text-align: left;
                      vertical-align: middle;
                    "
                    >FMI Product Source</label
                  >
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-7">
                  <select
                    class="xor-form-control"
                    id="lstFMIProductSourceForSearch"
                    required
                    [(ngModel)]="searchProductSourceID"
                    name="lstFMIProductSourceForSearch"
                    style="
                      width: 300px;
                      display: inline-block;
                      vertical-align: middle;
                    "
                    #lstFMIProductSource="ngModel"
                  >
                    <option
                      value=""
                      [selected]="fmiproduct.ProductSourceID === 0"
                      disabled
                    >
                      -- Select Product Source --
                    </option>
                    <ng-container
                      *ngFor="let fmiproductsource of fmiproductsources"
                    >
                      <option
                        *ngIf="!(fmiproductsource.ProductSourceID === 99)"
                        [value]="fmiproductsource.ProductSourceID"
                        [selected]="fmiproduct.ProductSourceID == fmiproductsource.ProductSourceID"
                      >
                        {{ fmiproductsource.Name }}
                      </option>
                    </ng-container>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group input-group has-feedback">
              <div class="row">
                <div class="col-lg-4">
                  <label
                    class="input-group-addon"
                    style="
                      width: 200px;
                      display: inline-block;
                      text-align: left;
                      vertical-align: middle;
                    "
                    >FMI Publication Number</label
                  >
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-7">
                  <input
                    name="searchOldPublicationNumber"
                    type="text"
                    style="
                      width: 300px;
                      display: inline-block;
                      vertical-align: middle;
                    "
                    class="form-control"
                    placeholder="FMI Publication Number"
                    [(ngModel)]="searchOldPublicationNumber"
                    id="searchOldPublicationNumber"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row"></div>
        <hr />
        <div class="row">
          <div class="col-sm-10">
            <div *ngIf="processing" style="width: 100%; text-align: left">
              <span style="color: darkred">Connecting ProManual....</span>
              <i
                class="fa fa-spinner fa-spin fa-pulse fa-2x"
                style="color: darkred"
              ></i>
            </div>
          </div>
          <div class="col-sm-2">
            <button
              type="button"
              style="width: 75px"
              class="btn btn-default"
              title="Pull"
              id="pullFromFMI"
              (click)="pullProductMetadataFromFMI()"
            >
              Pull
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  bsModal
  #fmiproductEditModal="bs-modal"
  class="modal fade"
  [config]="{ keyboard: false, backdrop: 'static' }"
  z-index="99"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" style="width: 90%">
    <div class="modal-content" data-bind="with: entity">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          aria-hidden="true"
          (click)="cancel()"
        >
          &times;
        </button>
        <h4 class="modal-title" id="myModalLabel">
          <span>
            {{ fmiproduct.Id === 0 ? 'Add Document' : 'Document Details &bull; '
            + fmiproduct.ProductName }}</span
          >
        </h4>
      </div>
      <div
        class="modal-body"
        data-bind="with: $data.entity"
        style="padding: 8px"
      >
        <ul class="nav nav-tabs nav-justified">
          <li role="presentation" [class.active]="uploadPDF !== true">
            <a role="tab" (click)="uploadPDF = false">Document Information</a>
          </li>
          <li
            role="presentation"
            [class.active]="uploadPDF === true && dataEntryMode === 'edit'"
          >
            <a (click)="setUploadTab()" role="tab">Upload PDF</a>
          </li>
        </ul>

        <div class="tab-content">
          <div
            id="fmiproductInfo"
            class="tab-pane"
            [class.in]="uploadPDF === false"
            [class.active]="uploadPDF === false"
          >
            <form (ngSubmit)="complete()" #detailForm="ngForm">
              <div class="row">
                <div class="col-lg-12">
                  <span>* All fields are required</span>
                </div>
                <div class="col-lg-4" *ngIf="!(fmiproduct.Id > 0)">
                  <button
                    type="button"
                    class="btn btn-primary btn-group-lg"
                    style="border-radius: 25px; margin-bottom: 12px"
                    title="Pull Document from FMI"
                    id="getFMIDocData"
                    (click)="openFMISearch()"
                  >
                    Pull Document from FMI
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div class="xor-form-group">
                    <div class="row">
                      <div class="col-lg-8">
                        <label class="xor-label" for="txtProductName"
                          >Publication Number</label
                        >
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-12">
                        <input
                          type="text"
                          class="xor-form-control"
                          id="txtProductName"
                          required
                          placeholder="Publication Number"
                          disabled="{{ (fmiproduct.Id > 0) || fmiproduct.IsPulledFromMidlandFMI}}"
                          [(ngModel)]="fmiproduct.ProductName"
                          name="txtProductName"
                          #txtProductName="ngModel"
                        />
                        <div
                          [hidden]='(txtProductName.valid || txtProductName.pristine) && fmiproduct.ProductName !== ""'
                          class="small alert alert-danger alert-danger-small"
                        >
                          Publication Number must be entered.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="(!fmiproduct.IsPulledFromMidlandFMI || (fmiproduct.Id != 0 && fmiproduct.IsPulledFromMidlandFMI )); else elseBlock"
                  class="col-lg-6"
                >
                  <div class="xor-form-group">
                    <label class="xor-label" for="txtProManualPublicationNumber"
                      >ProManual Publication Number</label
                    >
                    <input
                      type="text"
                      class="xor-form-control"
                      id="txtProManualPublicationNumber"
                      placeholder="ProManual Publication Number"
                      [(ngModel)]="fmiproduct.ProManualPublicationNumber"
                      name="txtProManualPublicationNumber"
                      #txtProManualPublicationNumber="ngModel"
                    />
                  </div>
                </div>
                <ng-template #elseBlock>
                  <div class="col-lg-4">
                    <div class="xor-form-group">
                      <label
                        class="xor-label"
                        for="txtProManualPublicationNumber"
                        >ProManual Publication Number</label
                      >
                      <input
                        type="text"
                        class="xor-form-control"
                        id="txtProManualPublicationNumber"
                        placeholder="ProManual Publication Number"
                        [(ngModel)]="fmiproduct.ProManualPublicationNumber"
                        name="txtProManualPublicationNumber"
                        #txtProManualPublicationNumber="ngModel"
                      />
                    </div>
                  </div>
                  <div class="col-lg-2">
                    <div class="xor-form-group">
                      <label class="xor-label" for="txtVersion">Version</label>
                      <input
                        type="text"
                        class="xor-form-control"
                        id="txtVersion"
                        placeholder="Version"
                        [(ngModel)]="version"
                        name="txtVersion"
                        #txtVersion="ngModel"
                      />
                    </div>
                  </div>
                </ng-template>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div class="xor-form-group">
                    <label class="xor-label" for="txtProductDescription"
                      >English Manual Title</label
                    >
                    <textarea
                      class="xor-form-control"
                      rows="2"
                      id="txtProductDescription"
                      required
                      placeholder="English Manual Title"
                      [(ngModel)]="fmiproduct.ProductDescription"
                      name="txtProductDescription"
                      #txtProductDescription="ngModel"
                    ></textarea>
                    <div
                      [hidden]="(txtProductDescription.valid || txtProductDescription.pristine) && fmiproduct.ProductDescription != null"
                      class="small alert alert-danger"
                    >
                      English Manual Title must be entered.
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="xor-form-group">
                    <label class="xor-label" for="txtProManualTitle"
                      >Translated Manual Title</label
                    >
                    <textarea
                      class="xor-form-control"
                      rows="2"
                      id="txtProManualTitle"
                      placeholder="Translated Manual Title"
                      [(ngModel)]="fmiproduct.ProManualTitle"
                      name="txtProManualTitle"
                      #txtProManualTitle="ngModel"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="xor-form-group">
                        <label class="xor-label" for="lstFMILanguage"
                          >Language</label
                        >
                        <select
                          class="xor-form-control"
                          id="lstFMILanguage"
                          required
                          [(ngModel)]="fmiproduct.Language"
                          name="lstFMILanguage"
                          disabled="{{ fmiproduct.IsPulledFromMidlandFMI }}"
                          #lstFMILanguage="ngModel"
                        >
                          <option
                            value=""
                            [selected]="fmiproduct.Language === null"
                          >
                            -- Select Language --
                          </option>
                          <option
                            *ngFor="let fmilanguage of fmilanguages"
                            [value]="fmilanguage.Name"
                            [selected]="fmiproduct.Language == fmilanguage.Name"
                          >
                            {{ fmilanguage.PM_Code }}&nbsp;-&nbsp;{{
                            fmilanguage.PM_Description }}
                          </option>
                        </select>
                        <div
                          [hidden]='(lstFMILanguage.valid || lstFMILanguage.pristine) && fmiproduct.Language !== ""'
                          class="small alert alert-danger"
                        >
                          Language must be selected.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="xor-form-group">
                        <label class="xor-label" for="lstPubType"
                          >Type of Book</label
                        >
                        <select
                          class="xor-form-control"
                          id="lstPubType"
                          required
                          [(ngModel)]="fmiproduct.PubType"
                          name="lstPubType"
                          disabled="{{ fmiproduct.IsPulledFromMidlandFMI }}"
                          #lstPubType="ngModel"
                        >
                          <option
                            value=""
                            [selected]="fmiproduct.PubType === null"
                          >
                            -- Select Type of Book --
                          </option>
                          <option
                            *ngFor="let fmipubtype of getfmipubtypes"
                            [value]="fmipubtype.Name"
                            [selected]="fmiproduct.PubType == fmipubtype.Name"
                          >
                            {{ fmipubtype.Name }}
                          </option>
                        </select>
                        <div
                          [hidden]='(lstPubType.valid || lstPubType.pristine) && fmiproduct.PubType !== ""'
                          class="small alert alert-danger"
                        >
                          Type of Book must be selected.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="row"
                    [hidden]="fmiproduct.IsNonConformingDocument == true"
                  >
                    <div class="col-lg-4">
                      <div class="xor-form-group">
                        <label class="xor-label" for="txtBookPrice"
                          >Book Price</label
                        >
                        <input
                          type="number"
                          class="xor-form-control"
                          id="txtBookPrice"
                          required
                          placeholder="Book Price"
                          [(ngModel)]="fmiproduct.BookPrice"
                          name="txtBookPrice"
                          #txtBookPrice="ngModel"
                        />
                        <div
                          [hidden]="txtBookPrice.valid || txtBookPrice.pristine"
                          class="small alert alert-danger"
                        >
                          Book Price must be entered.
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4">
                      <div class="xor-form-group">
                        <label class="xor-label" for="txtCDPrice"
                          >CD Price</label
                        >
                        <input
                          type="number"
                          class="xor-form-control"
                          id="txtCDPrice"
                          required
                          placeholder="CD Price"
                          [(ngModel)]="fmiproduct.CDPrice"
                          name="txtCDPrice"
                          #txtCDPrice="ngModel"
                        />
                        <div
                          [hidden]="txtCDPrice.valid || txtCDPrice.pristine"
                          class="small alert alert-danger"
                        >
                          CD Price must be entered.
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4">
                      <div class="xor-form-group">
                        <label class="xor-label" for="txtFlashDrivePrice"
                          >Flash Drive Price</label
                        >
                        <input
                          type="number"
                          class="xor-form-control"
                          id="txtFlashDrivePrice"
                          required
                          placeholder="Flash Drive Price"
                          [(ngModel)]="fmiproduct.FlashDrivePrice"
                          name="txtFlashDrivePrice"
                          #txtFlashDrivePrice="ngModel"
                        />
                        <div
                          [hidden]="txtFlashDrivePrice.valid || txtFlashDrivePrice.pristine"
                          class="small alert alert-danger"
                        >
                          Flash Drive Price must be entered.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="row"
                    [hidden]="fmiproduct.IsNonConformingDocument == true"
                  >
                    <div class="col-lg-12">
                      <div class="xor-form-group">
                        <label class="xor-label" for="lstFMIDivisions"
                          >Division</label
                        >
                        <select
                          class="xor-form-control"
                          id="lstFMIDivisions"
                          required
                          [(ngModel)]="fmiproduct.Division"
                          name="lstFMIDivisions"
                          disabled="{{ fmiproduct.IsPulledFromMidlandFMI }}"
                          #lstFMIDivisions="ngModel"
                        >
                          <option
                            value=""
                            [selected]="fmiproduct.Division === null"
                          >
                            -- Select Division --
                          </option>
                          <option
                            *ngFor="let fmidivision of fmidivisions"
                            [value]="fmidivision.Name"
                            [selected]="fmiproduct.Division == fmidivision.Name"
                          >
                            {{ fmidivision.Name }}
                          </option>
                        </select>
                        <div
                          [hidden]="lstFMIDivisions.valid || lstFMIDivisions.pristine"
                          class="small alert alert-danger"
                        >
                          Division must be selected.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="xor-form-group">
                        <label class="xor-label" for="lstFMIDivisions"
                          >Titania Link</label
                        >
                        <div>
                          <textarea
                            class="xor-form-control"
                            rows="3"
                            id="txtTitaniaUrl"
                            placeholder="Titania Link (https://...)"
                            [(ngModel)]="fmiproduct.TitaniaUrl"
                            (ngModelChange)="titaniaUrlTouched = true; validateTitaniaUrl($event)"
                            (blur)="titaniaUrlTouched = true; validateTitaniaUrl()"
                            name="txtTitaniaUrl"
                            #txtTitaniaUrl="ngModel"
                            style="height: 3em"
                          ></textarea>
                          <div
                            *ngIf="fmiproduct.TitaniaUrl && titaniaUrlTouched"
                            style="margin-top: 4px"
                          >
                            <span
                              *ngIf="!titaniaUrlValid"
                              class="small alert alert-danger"
                              style="display: inline-block; padding: 4px 8px"
                              >Enter a valid http(s) URL.</span
                            >
                            <a
                              *ngIf="titaniaUrlValid"
                              [href]="fmiproduct.TitaniaUrl"
                              target="_blank"
                              rel="noopener"
                              class="btn btn-link btn-xs"
                              style="padding-left: 0"
                              title="Open Titania Link in new tab"
                              >Test Link
                              <i
                                class="fa fa-external-link"
                                aria-hidden="true"
                              ></i
                            ></a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="checkbox">
                        <label class="xor-label"
                          ><input
                            id="PublishToProManual"
                            name="PublishToProManual"
                            type="checkbox"
                            [(ngModel)]="fmiproduct.PublishToProManual"
                            disabled="{{ fmiproduct.IsPulledFromMidlandFMI || fmiproduct.IsNonConformingDocument}}"
                          />Publish to ProManual Only</label
                        >
                      </div>
                      <div
                        style="
                          padding: 9px 15px;
                          border-bottom: 1px solid #eee;
                          color: #468847;
                          background-color: #dff0d8;
                          border-color: #d6e9c6;
                        "
                        *ngIf="fmiproduct.PublishToProManual"
                      >
                        <h6>
                          Publish to ProManual Only is selected! Your document
                          WILL NOT be made available through Store Front. The
                          FMI entry will still be created and the document will
                          still be provided to Midland. Remove from Website date
                          will be set to current date and time. Use FMI to
                          change this status.
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-lg-2"
                  [hidden]="fmiproduct.IsNonConformingDocument == true"
                >
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="xor-form-group">
                        <label class="xor-label" for="lstFMIModels"
                          >Model</label
                        >
                        <select
                          class="xor-form-control"
                          size="17"
                          multiple
                          id="lstFMIModels"
                          required
                          [(ngModel)]="selectedModels"
                          name="lstFMIModels"
                          disabled="{{ fmiproduct.IsPulledFromMidlandFMI }}"
                          #lstFMIModels="ngModel"
                        >
                          <option
                            *ngFor="let fmimodel of fmimodels"
                            [value]="fmimodel.Name"
                          >
                            {{ fmimodel.Name }}
                          </option>
                        </select>
                        <div
                          [hidden]="(lstFMIModels.valid || lstFMIModels.pristine) && selectedModels.length > 0"
                          class="small alert alert-danger"
                        >
                          At least one Model must be selected.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-lg-2"
                  [hidden]="fmiproduct.IsNonConformingDocument == true"
                >
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="xor-form-group">
                        <label class="xor-label" for="lstFMIAvailableTemplates"
                          >Available Print Templates</label
                        >
                        <select
                          class="xor-form-control"
                          size="6"
                          multiple
                          id="lstFMIAvailableTemplates"
                          disabled="{{ fmiproduct.IsPulledFromMidlandFMI }}"
                          [(ngModel)]="selectedAvailableTemplates"
                          name="lstFMIAvailableTemplates"
                        >
                          <option
                            *ngFor="let lstTemplate of fmiavailabletemplates"
                            [value]="lstTemplate"
                          >
                            {{ lstTemplate }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="xor-form-group">
                        <div class="btn-group btn-group-sm">
                          <button
                            type="button"
                            class="btn btn-info"
                            title="Add Print Template"
                            (click)="addTemplate()"
                          >
                            <i
                              data-toggle="tooltip"
                              class="fa fa-plus fa-lg"
                            ></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-info"
                            title="Remove Print Template"
                            (click)="removeTemplate()"
                          >
                            <i
                              data-toggle="tooltip"
                              class="fa fa-minus fa-lg"
                            ></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="xor-form-group">
                        <label class="xor-label" for="lstFMIAssignedTemplates"
                          >Print Templates Assigned</label
                        >
                        <select
                          class="xor-form-control"
                          size="5"
                          multiple
                          id="lstFMIAssignedTemplates"
                          disabled="{{ fmiproduct.IsPulledFromMidlandFMI }}"
                          [(ngModel)]="selectedAssignedTemplates"
                          name="lstFMIAssignedTemplates"
                        >
                          <option
                            *ngFor="let lstTemplate of fmiassignedtemplates"
                            [value]="lstTemplate"
                          >
                            {{ lstTemplate }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-2">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="xor-form-group">
                        <label class="xor-label" for="lstFMIProductSource"
                          >FMI Product Source</label
                        >
                        <select
                          class="xor-form-control"
                          id="lstFMIProductSource"
                          required
                          [(ngModel)]="fmiproduct.ProductSourceID"
                          name="lstFMIProductSource"
                          disabled="{{ fmiproduct.IsPulledFromMidlandFMI }}"
                          #lstFMIProductSource="ngModel"
                          (change)="ProductSourceSelected();"
                        >
                          <option
                            value=""
                            [selected]="fmiproduct.ProductSourceID === 0"
                            disabled
                          >
                            -- Select Product Source --
                          </option>
                          <option
                            *ngFor="let fmiproductsource of fmiproductsources"
                            [value]="fmiproductsource.ProductSourceID"
                            [selected]="fmiproduct.ProductSourceID == fmiproductsource.ProductSourceID"
                          >
                            {{ fmiproductsource.Name }}
                          </option>
                        </select>
                        <div
                          [hidden]="(lstFMIProductSource.valid || lstFMIProductSource.pristine) && fmiproduct.ProductSourceID !== 0"
                          class="small alert alert-danger"
                        >
                          Product Source must be selected.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="row"
                    [hidden]="fmiproduct.IsNonConformingDocument == true"
                  >
                    <div class="col-lg-12">
                      <div class="xor-form-group">
                        <label class="xor-label" for="txtFileMetadataID"
                          >FMI MetaDataId</label
                        >
                        <input
                          type="text"
                          class="form-control xor-form-control"
                          id="txtFileMetadataID"
                          disabled
                          [(ngModel)]="fmiproduct.FileMetadataID"
                          name="txtFileMetadataID"
                          #txtProductName="ngModel"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class="row"
                    [hidden]="fmiproduct.IsNonConformingDocument == true"
                  >
                    <div class="col-lg-12">
                      <div class="xor-form-group">
                        <label class="xor-label" for="CreatedOn"
                          >Created Date</label
                        >
                        <input
                          id="CreatedOn"
                          name="CreatedOn"
                          type="datetime-local"
                          class="form-control xor-form-control"
                          placeholder="Created On"
                          [(ngModel)]="fmiproduct.CreatedOn"
                          disabled="disabled"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class="row"
                    [hidden]="fmiproduct.IsNonConformingDocument == true"
                  >
                    <div class="col-lg-12">
                      <div class="xor-form-group">
                        <label class="xor-label" for="CreatedBy"
                          >Created By</label
                        >
                        <input
                          id="CreatedBy"
                          name="CreatedBy"
                          type="text"
                          class="form-control xor-form-control"
                          placeholder="Created By"
                          [(ngModel)]="fmiproduct.CreatedBy"
                          disabled="disabled"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class="row"
                    [hidden]="fmiproduct.IsNonConformingDocument == true"
                  >
                    <div class="col-lg-12">
                      <div class="xor-form-group">
                        <label class="xor-label" for="ModifiedOn"
                          >Modified Date</label
                        >
                        <input
                          id="ModifiedOn"
                          name="ModifiedOn"
                          type="datetime-local"
                          class="form-control xor-form-control"
                          placeholder="Modified On"
                          [(ngModel)]="fmiproduct.ModifiedOn"
                          disabled="disabled"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class="row"
                    [hidden]="fmiproduct.IsNonConformingDocument == true"
                  >
                    <div class="col-lg-12">
                      <div class="xor-form-group">
                        <label class="xor-label" for="ModifiedBy"
                          >Modified By</label
                        >
                        <input
                          id="ModifiedBy"
                          name="ModifiedBy"
                          type="text"
                          class="form-control xor-form-control"
                          placeholder="Modified By"
                          [(ngModel)]="fmiproduct.ModifiedBy"
                          disabled="disabled"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-lg-10"
                  style="
                    margin-top: 0px;
                    padding: 8px 24px 8px;
                    text-align: right;
                  "
                >
                  <div *ngIf="savingToFMI">
                    <span style="color: darkred">Saving to FMI ...</span>
                    <i
                      class="fa fa-spinner fa-spin fa-pulse fa-2x"
                      style="color: darkred"
                    ></i>
                  </div>
                </div>
                <div
                  class="col-lg-2"
                  style="
                    margin-top: 0px;
                    padding: 8px 24px 8px;
                    text-align: right;
                  "
                >
                  <button
                    type="button"
                    class="btn btn-default"
                    (click)="cancel()"
                  >
                    Close
                  </button>
                  <button type="submit" class="btn btn-success">Save</button>
                </div>
              </div>
            </form>
          </div>
          <div
            id="pdfUpload"
            class="tab-pane"
            [class.in]="uploadPDF === true && dataEntryMode === 'edit'"
            [class.active]="uploadPDF === true && dataEntryMode === 'edit'"
          >
            <div class="row">
              <div class="col-lg-12">
                <span>
                  * When uploading a document for ProManual, PDF name must
                  follow ProManual naming standards.
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <span *ngIf="!isNonConforming">
                  * PDF name must match the Publication Number entered in the
                  Document Information tab and include the version number.
                </span>
                <span *ngIf="isNonConforming">
                  * PDF name must match the Publication Number entered in the
                  Document Information tab. Do not include the version number
                  for non-conforming documents, it is calculated. The next
                  version is '{{ NextVersion }}'.
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group">
                  <label for="ProductName">Publication Number</label>
                  <span class="form-control disabled"
                    >{{ fmiproduct.IsPulledFromMidlandFMI ?
                    fmiproduct.ProManualPublicationNumber:fmiproduct.ProductName}}{{!isNonConforming
                    ? '-****' : ''}}</span
                  >
                  <!--<input id="ProductName" name="ProductName" type="text" class="form-control" placeholder="Publication Number" [(ngModel)]="fmiproduct.ProductName" disabled />-****-->
                </div>
              </div>
              <div class="col-lg-6">&nbsp;</div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <form (ngSubmit)="UploadFile()" #pdfForm="ngForm">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="xor-form-group">
                        <label class="xor-label" for="pdfFileInput"
                          >Choose a file:</label
                        >
                        <input
                          id="pdfFileInput"
                          type="file"
                          accept="application/pdf"
                          style="width: 75%"
                          (change)="pdfFileChange()"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-12">
                      <div class="checkbox">
                        <label class="xor-label"
                          ><input
                            id="chkUploadPDFProManul"
                            name="chkUploadPDFProManul"
                            type="checkbox"
                            [(ngModel)]="uploadPDFProManul"
                          />Upload to ProManual</label
                        >
                      </div>
                      <div class="checkbox">
                        <label class="xor-label"
                          ><input
                            id="chkUploadPDFFMI"
                            name="chkUploadPDFFMI"
                            type="checkbox"
                            [(ngModel)]="uploadPDFFMI"
                          />Upload to FMI FTP Server</label
                        >
                      </div>
                      <button
                        type="submit"
                        class="btn btn-warning btn-sm"
                        [disabled]="!pdfForm.form.valid"
                      >
                        Upload File
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6" *ngIf="processingAzurePDF">
                      <div style="width: 100%; text-align: center">
                        <span style="color: darkred"
                          >Uploading to ProManual ...</span
                        >
                        <i
                          class="fa fa-spinner fa-spin fa-pulse fa-2x"
                          style="color: darkred"
                        ></i>
                      </div>
                    </div>
                    <div
                      id="divUploadAzurePDFCompleted"
                      class="col-sm-6"
                      *ngIf="uploadAzurePDFCompleted"
                    >
                      <div style="width: 100%; text-align: center">
                        <span style="color: darkred"
                          >Document successfully uploaded to ProManual.</span
                        >
                        <br />
                        <span style="color: darkred"
                          >Click on Browse/Choose File to upload another.</span
                        >
                      </div>
                    </div>
                    <div
                      id="divUploadAzurePDFError"
                      class="col-sm-6"
                      *ngIf="uploadAzurePDFError"
                    >
                      <div style="width: 100%; text-align: center">
                        <span style="color: darkred"
                          >ERROR uploading to ProManual</span
                        >
                        <br />
                        <span style="color: darkred">{{ errMsgAzurePDF }}</span>
                      </div>
                    </div>
                    <div class="col-sm-6" *ngIf="processingFMIPDF">
                      <div style="width: 100%; text-align: center">
                        <span style="color: darkred"
                          >Uploading to FMI FTP Server ...</span
                        >
                        <i
                          class="fa fa-spinner fa-spin fa-pulse fa-2x"
                          style="color: darkred"
                        ></i>
                      </div>
                    </div>
                    <div
                      id="divUploadFMIPDFCompleted"
                      class="col-sm-6"
                      *ngIf="uploadFMIPDFCompleted"
                    >
                      <div style="width: 100%; text-align: center">
                        <span style="color: darkred"
                          >Document successfully uploaded to FMI FTP
                          Server.</span
                        >
                        <br />
                        <span style="color: darkred"
                          >Click on Browse/Choose File to upload another.</span
                        >
                      </div>
                    </div>
                    <div
                      id="divUploadFMIPDFError"
                      class="col-sm-6"
                      *ngIf="uploadFMIPDFError"
                    >
                      <div style="width: 100%; text-align: center">
                        <span style="color: darkred"
                          >ERROR uploading to FMI FTP Server</span
                        >
                        <br />
                        <span style="color: darkred">{{ errMsgFMIPDF }}</span>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="col-lg-6">&nbsp;</div>
            </div>
            <div class="row">
              <div
                class="col-lg-12"
                style="vertical-align: bottom; text-align: right"
              >
                <button
                  type="button"
                  class="btn btn-default"
                  (click)="cancel()"
                >
                  Close
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <span>Version History</span>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <table
                  class="table m-table table-bordered table-hover table-heading"
                >
                  <colgroup>
                    <col style="width: 75px" />
                    <col style="width: 400px" />
                    <col style="width: 100px" />
                    <col style="width: 100px" />
                    <col style="width: auto" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>
                        <span
                          style="
                            line-height: 1.42857143;
                            font-weight: bold;
                            vertical-align: middle;
                            text-align: center;
                          "
                          >Id</span
                        >
                      </th>
                      <th>
                        <span
                          style="
                            line-height: 1.42857143;
                            font-weight: bold;
                            vertical-align: middle;
                            text-align: center;
                          "
                          >Version</span
                        >
                      </th>
                      <th>
                        <span
                          style="
                            line-height: 1.42857143;
                            font-weight: bold;
                            vertical-align: middle;
                            text-align: center;
                          "
                          >Updated</span
                        >
                      </th>
                      <th>
                        <span
                          style="
                            line-height: 1.42857143;
                            font-weight: bold;
                            vertical-align: middle;
                            text-align: center;
                          "
                          >Replaces</span
                        >
                        <br />
                        <span
                          style="
                            line-height: 1.42857143;
                            font-weight: bold;
                            vertical-align: middle;
                            text-align: center;
                          "
                          >Version Id</span
                        >
                      </th>
                      <th>
                        <span
                          style="
                            line-height: 1.42857143;
                            font-weight: bold;
                            vertical-align: middle;
                            text-align: center;
                          "
                          >Publishing</span
                        >
                      </th>
                    </tr>
                  </thead>
                </table>
                <div
                  style="height: 300px; overflow-y: scroll; margin-top: -20px"
                >
                  <table
                    class="table m-table table-bordered table-hover table-heading"
                    style="margin-bottom: 0px"
                  >
                    <colgroup>
                      <col style="width: 75px" />
                      <col style="width: 400px" />
                      <col style="width: 100px" />
                      <col style="width: 100px" />
                      <col style="width: auto" />
                    </colgroup>
                    <tbody>
                      <tr *ngFor="let document of historyDocuments">
                        <td>
                          <span>{{ document.Id }}</span>
                        </td>
                        <td>
                          <span>{{ document.Version }}</span>
                        </td>
                        <td>
                          <span
                            >{{ document.Updated | amDateFormat: 'MM/DD/YYYY'
                            }}</span
                          >
                        </td>
                        <td>
                          <span>{{ document.UpdateToId }}</span>
                        </td>
                        <td>
                          <span>{{ document.Publishing }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  bsModal
  #fmiproductFilterModal="bs-modal"
  class="modal fade"
  [config]="{ keyboard: false, backdrop: 'static' }"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" style="width: 960px">
    <form (ngSubmit)="applyFilter()">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
            (click)="closeFilter()"
          >
            &times;
          </button>
          <h4
            class="modal-title"
            id="myModalLabel"
            style="display: inline-block"
          >
            <span>Document Management Filter</span>
          </h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group input-group has-feedback">
                <label
                  class="control-group input-group-addon"
                  for="filterProductName"
                  >Publication Number</label
                >
                <input
                  id="filterProductName"
                  name="filterProductName"
                  type="text"
                  class="form-control"
                  placeholder="Publication Number"
                  [(ngModel)]="filterProductName"
                />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group input-group has-feedback">
                <label
                  class="control-group input-group-addon"
                  for="filterProductDescription"
                  >Manual Title</label
                >
                <input
                  id="filterProductDescription"
                  name="filterProductDescription"
                  type="text"
                  class="form-control"
                  placeholder="Manual Title"
                  [(ngModel)]="filterProductDescription"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group input-group has-feedback">
                <label
                  class="control-group input-group-addon"
                  for="filterFMILanguage"
                  >Language</label
                >
                <select
                  id="filterFMILanguage"
                  name="filterFMILanguage"
                  [(ngModel)]="filterFMILanguage"
                  class="form-control"
                >
                  <option value="" [selected]="filterFMILanguage === null">
                    -- Select Language --
                  </option>
                  <option
                    *ngFor="let fmilanguage of fmilanguages"
                    [value]="fmilanguage.Name"
                    [selected]="fmilanguage.Name == filterFMILanguage"
                  >
                    {{ fmilanguage.PM_Code }}&nbsp;-&nbsp;{{
                    fmilanguage.PM_Description}}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group input-group has-feedback">
                <label
                  class="control-group input-group-addon"
                  for="filterPubType"
                  >Division</label
                >
                <select
                  id="filterDivision"
                  name="filterDivision"
                  [(ngModel)]="filterDivision"
                  class="form-control"
                >
                  <option value="" [selected]="filterDivision === null">
                    -- Select Division --
                  </option>
                  <option
                    *ngFor="let fmidivision of fmidivisions"
                    [value]="fmidivision.Name"
                    [selected]="fmidivision.Name == filterDivision"
                  >
                    {{ fmidivision.Name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <div class="form-group input-group has-feedback">
                <label
                  class="control-group input-group-addon"
                  for="filterCreatedBy"
                  >Created By</label
                >
                <input
                  id="filterCreatedBy"
                  name="filterCreatedBy"
                  type="text"
                  class="form-control"
                  placeholder="Created By"
                  [(ngModel)]="filterCreatedBy"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-success"
            *ngIf="filterApplied"
            (click)="clearFilter()"
          >
            Clear Filter
          </button>
          <button type="submit" class="btn btn-default">Apply Filter</button>
        </div>
      </div>
    </form>
  </div>
</div>

<div
  bsModal
  #errPrintTemplate="bs-modal"
  class="modal fade"
  [config]="{ keyboard: false, backdrop: 'static' }"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel">Print Template Warning</h4>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12">{{ printTemplateErrorMsg }}</div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-warning"
          (click)="closePrintTemplateError()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<div
  bsModal
  #errModal="bs-modal"
  class="modal fade"
  [config]="{ keyboard: false, backdrop: 'static' }"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel">{{ errModalTitle }}</h4>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12">{{ errModalMsg }}</div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-warning" (click)="closeErrModal()">
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<div
  bsModal
  #deleteConfirmation="bs-modal"
  class="modal fade"
  [config]="{ keyboard: false, backdrop: 'static' }"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel">
          Delete Document Confirmation - {{ deleteConfirmationProductName }}
        </h4>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12">
            <span
              style="
                line-height: 1.42857143;
                font-weight: bold;
                vertical-align: middle;
                text-align: center;
              "
            >
              Deleting this entry will remove this manual from view in ProManual
              and the ProManual administrative site. The manual will still be
              available in FMI and Storefront. To also remove this manual from
              Storefront, set a “Remove from Site” date in Elanders’ FMI
              customer portal.
            </span>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-warning"
          (click)="deleteDocument()"
        >
          Confirm Delete
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="cancelDeleteConfirmation()"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
